import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import EditVendorBill from "../components/EditVendorBill";

const EditVendorBillPage = () => {
    return (
        <>
            {/* MasterLayout */}
            <MasterLayout>
                {/* Breadcrumb */}
                <Breadcrumb title='Edit Bill' />

                <EditVendorBill />

            </MasterLayout>
        </>
    );
};

export default EditVendorBillPage;
